module.exports = __webpack_public_path__ + "img/accessCompleted.acaa0f07.png";